import { Navigate, useParams } from 'react-router-dom';

import { TFPageContent, TFPageHeader } from '@tf/shared';
import { T } from '@tf/utils';

import { type ProfileGroups, useProfileGroupsSchemas } from '@/core/api/profiles';
import { appStore } from '@/core/stores';
import { ProfileGroupsTable } from '@/components/profiles/ProfileGroupsTable';
import { AddProfileButton } from '@/components/shared';

export const ProfileGroupsRoute = () => {
	const { groupLabel } = useParams<{ groupLabel: string }>();
	const { data: profileGroups, isLoading } = useProfileGroupsSchemas();
	const tenant = appStore.tenant?.get();

	T.assertNotNullish(tenant, 'no tenant in appStore');
	T.assertNotNullish(groupLabel, 'groupLabel param is required');

	if (isLoading) {
		return null;
	}

	const groupConfig = profileGroups?.groups?.find(
		(group: ProfileGroups) => group.label.toLowerCase() === groupLabel?.toLowerCase()
	);

	const isFirstGroup =
		profileGroups?.groups && profileGroups.groups[0]?.label.toLowerCase() === groupLabel?.toLowerCase();

	if (!groupConfig || isFirstGroup) {
		return <Navigate to="/" replace />;
	}

	return (
		<>
			<TFPageHeader tenant={tenant} title={groupConfig.label} toolbar={<AddProfileButton />} />
			<TFPageContent>
				<ProfileGroupsTable kinds={groupConfig.kinds} label={groupConfig.label} />
			</TFPageContent>
		</>
	);
};
